import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatrolTemplateService {

  constructor(
    private httpClient: HttpClient
  ) { }
  // 获取所有巡检模板
  getPatrolTemplates(): Observable<any[]> {
    return this.httpClient.get('plan/api/business/patrol/queryAllPatrolTemplates').pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 根据过滤字符串查询模板
  getPatrolTemplatesByFilterString(ptLike: any): Observable<any[]> {
    const url = 'plan/api/business/patrol/queryPatrolTemplatesByFilterString?ptLike=' + ptLike;
    return this.httpClient.get(url).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 根据条件查询巡检模板
  getPatrolTemplatesByCondition(parm: any, pageNum: number, pageSize: number): Observable<any[]> {
    let url = 'plan/api/business/patrol/queryPatrolTemplatesByCondition' + '?pageNum=' + pageNum +
    '&pageSize=' + pageSize;
    if (!this.isEmpty(parm.ptName)) {
      url = url + '&ptName=' + parm.ptName;
    }
    if (!this.isEmpty(parm.createBy)) {
      url = url + '&createBy=' + parm.createBy;
    }
    if (!this.isEmpty(parm.typeNo)) {
      url = url + '&typeNo=' + parm.typeNo;
    }
    return this.httpClient.get(url).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 获取所有巡检模板，包括模板中的控件
  getPatrolTemplatesContainControls(): Observable<any[]> {
    return this.httpClient.get('plan/api/business/patrol/queryPatrolTemplates').pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 根据巡检ID查询巡检模板
  getPatrolTemplatesByPtno(ptno): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/patrol/queryPatrolTemplatesByPtno/${ptno}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 删除巡检模板
  deletePatrolTemplate(ptno): Observable<any[]> {
    return this.httpClient.delete(`plan/api/business/patrol/deleteTemplate/${ptno}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 更新巡检模板
  updatePatrolTemplate(patrolTemplate: any): Observable<any[]> {
    if (!this.isEmpty(patrolTemplate.controls && patrolTemplate.controls.length > 0)){
      patrolTemplate.controls.forEach(( control: any) => {
        control.ptNo = patrolTemplate.ptNo;
      });
    }
    patrolTemplate = this.updateTemplate(patrolTemplate);
    return this.httpClient.put('plan/api/business/patrol/updateTemplate', patrolTemplate).pipe(
      map((res: any) => res)
    );
  }
  // 根据模板ID查询所有控件
  getControlsByPtno(ptno: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/patrol/queryByPtno/${ptno}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 根据控件ID查询控件
  getControlByPtcno(ptcno: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/patrol/queryByPtcno/${ptcno}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 新增加模板
  addTemplate(template: any): Observable<any[]> {
    template = this.updateTemplate(template);
    return this.httpClient.post(`plan/api/business/patrol/addTemplate`, template).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 对已经存在的模板新增加控件
  addControl(control: any): Observable<any[]> {
    return this.httpClient.post(`plan/api/business/patrol/addControl`, control).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 删除已存在模板的控件
  deleteControl(ptcno: any): Observable<any[]> {
    return this.httpClient.delete(`plan/api/business/patrol/deleteControl/${ptcno}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
   // 批量删除模板
   batchDeleteTemplates(ptnos: any): Observable<any[]> {
    const ls: string[] = Array.from(ptnos);
    return this.httpClient.delete(`plan/api/business/patrol/batchDeleteTemplates`, {
      params: {ptnos: ls}
  } ).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  updateTemplate(template: any){
    if (!this.isEmpty(template.controls && template.controls.length > 0)){
      template.controls.forEach(( control: any) => {
        if (control.options.length === 0){
          control.options = '';
        }
        if (control.options.length > 0){
          let str = '';
          control.options.forEach((option: any, index: any) => {
            if ( control.options.length === index + 1){
              str = str + option.value;
            }else{
              str = str + option.value + ',';
            }
          });
          control.options = str;
        }
      });
    }
    return template;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
